import styled from 'styled-components'

const Container = styled.div`
  width: 100%;
  position: fixed;
  left: -50px;
`

export { Container }



// WEBPACK FOOTER //
// ./src/Components/Background/styles.js